<template>
  <component :is="container" />
</template>

<script setup lang="ts">
  import meta from './head/meta';
  import link from './head/link';

  // Тут мы включаем layout-ы через NuxtLayout/NuxtPage
  // Однако мы не можем вынести сюда любые стили/компоненты
  // Потому что app.vue общий для сайта и для AMP версии
  // Поэтому тут нужно грузить AppContainer асинхронно
  const AppContainer = defineAsyncComponent(() => import('~/containers/AppContainer.vue'));
  const AmpAppContainer = defineAsyncComponent(() => import('~/containers/AppContainer.amp.vue'));

  const nuxtApp = useNuxtApp();
  const container = computed(() => (nuxtApp.$isAMP ? AmpAppContainer : AppContainer));

  useHead({
    htmlAttrs: {
      lang: 'ru-RU',
    },
    title: 'Горящая изба - Женское издание про всё',
    link: [
      { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png?v=2' },
      { rel: 'alternate', type: 'application/rss+xml', href: 'https://burninghut.ru/feed/' },
      ...link,
    ],

    meta,
  });
</script>
